class ModalManager {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.modalList = []
    }
    run() {
        document.querySelectorAll('[data-modal]').forEach((el) => {
            const modal = new Modal(el, this)
            modal.run()

            this.modalList.push(modal)
        })

        document.addEventListener('click', () => {
            this.modalList.forEach(modal => modal.close())
        })
    }
}

class Modal {
    constructor(el, parent) {
        this.el = el
        this.idx = el.dataset.modal || ''
        this.parent = parent
    }
    run() {
        document.querySelectorAll('[data-modal-action="' + this.idx + '"]').forEach((elAction) => {
            elAction.addEventListener('click', (ev) => {
                ev.stopPropagation();
                this.open()
            }, false)
        })

        this.el.querySelectorAll('[data-modal-content]').forEach((elContent) => {
            elContent.addEventListener('click', (ev) => {
                ev.stopPropagation();
            })
        })
        this.el.querySelectorAll('[data-modal-action]').forEach((elAction) => {
            elAction.addEventListener('click', () => this.toggle(), false)
        })
        this.el.querySelectorAll('[data-modal-action-close]').forEach((elAction) => {
            elAction.addEventListener('click', () => this.close(), false)
        })
    }
    open() {
        this.el.style.display = "block"
    }
    toggle() {
        if ("block" === this.el.style.display) {
            this.el.style.display = "none"
        } else {
            this.el.style.display = "block"
        }
    }
    close() {
        this.el.style.display = "none"
    }
}

export default ModalManager